'use client';

import { faCirclePause, faHeadphones } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { calculateMinutes } from '../utils/utils';
import { Dispatch, SetStateAction } from 'react';

export default function ListenAction({
  duration,
  playStatus,
  setPlayStatus,
}: {
  duration: number;
  playStatus: boolean;
  setPlayStatus: Dispatch<SetStateAction<boolean>>;
}) {
  return (
    <button
      type="button"
      className="mb-2 block text-xs text-gray-600"
      onClick={() => setPlayStatus((prev) => !prev)}
    >
      {playStatus ? (
        <FontAwesomeIcon icon={faCirclePause} type="button" aria-label="pause" />
      ) : (
        <FontAwesomeIcon icon={faHeadphones} type="button" aria-label="play" />
      )}{' '}
      Listen <>{calculateMinutes(duration || 0)} min</>
    </button>
  );
}
